import { env } from '../env';
import { AdminBlogDetail, AdminBlogSummary, BlogCreateCommand, BlogUpdateCommand } from '../types/blog';

const BASE_URL = env.apiUrl;

function authHeaders(accessToken: string): HeadersInit {
  return { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' };
}

export async function adminListBlogs(accessToken: string): Promise<AdminBlogSummary[]> {
  const res = await fetch(`${BASE_URL}/api/blogs/admin`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load blogs');
  return res.json();
}

export async function adminGetBlog(accessToken: string, blogId: number): Promise<AdminBlogDetail> {
  const res = await fetch(`${BASE_URL}/api/blogs/${blogId}/admin`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load blog');
  return res.json();
}

export async function createBlog(accessToken: string, cmd: BlogCreateCommand): Promise<{ blogId: number }> {
  const res = await fetch(`${BASE_URL}/api/blogs`, {
    method: 'POST',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to create blog');
  return res.json();
}

export async function updateBlog(
  accessToken: string,
  blogId: number,
  cmd: BlogUpdateCommand
): Promise<{ blogId: number }> {
  const res = await fetch(`${BASE_URL}/api/blogs/${blogId}`, {
    method: 'PUT',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to update blog');
  return res.json();
}

export async function deleteBlog(accessToken: string, blogId: number): Promise<void> {
  const res = await fetch(`${BASE_URL}/api/blogs/${blogId}`, {
    method: 'DELETE',
    headers: authHeaders(accessToken),
  });
  if (!res.ok) throw new Error('Failed to delete blog');
}
